import React from 'react'
import FileAComplainComp from '../../components/dispute/FileAComplain'

export default function FileAComplain() {
  return (
    <FileAComplainComp />
  )
}
